import { TerminalConfiguration } from "@/service/common/terminal_configuration_service";
import { TerminalConfigurationInterface } from "@/interface/common/terminal_configuration_interface";
import { AppPathConfig } from "@/helper/app_path_config";
import { isLocalhost } from "@maersk-global/shared-js";

export class TerminalConfigurationRepository {
  async getTerminalConfiguration(id: string): Promise<TerminalConfigurationInterface> {
    const service = new TerminalConfiguration();
    const isLocalhostRef = isLocalhost(window?.location.hostname);
    try {
      const baseurl = isLocalhostRef ? `${AppPathConfig.localhostString}:${process.env.PORT}` : window?.location.origin;
      const path = baseurl + AppPathConfig.configurationPath;
      const url = `${path}/${id}.json?rev=${Date.now()}`;
      const containers: TerminalConfigurationInterface = await service.fetchTerminalConfiguration(url);
      return containers;
    } catch (e) {
      throw Error;
    }
  }
}
